import {generateAsyncActionCreators} from '../core/reduxUtils';
import {USER_INFO_JWT_TOKEN_COOKIE_NAME} from '../../modules/account/accountConstants';

const getCustomerInfoActionCreators = generateAsyncActionCreators(
  'GET_CUSTOMER_INFO',
  (params) => {
    return {
      params: {
        [USER_INFO_JWT_TOKEN_COOKIE_NAME]: params,
      },
    }
  },
);

const actionCreators = {
  getCustomerInfo: {
    ...getCustomerInfoActionCreators,
  },
};

export {
  actionCreators,
  getCustomerInfoActionCreators,
};
